export default __webpack_public_path__ + "static/media/IMG_20220201_140147_114 - Mysterious gamer.6558e3b8.jpg";